import EmailLink from "./EmailLink";
export default EmailLink;